import { render, staticRenderFns } from "./CheckBoxPropertyEditor.vue?vue&type=template&id=d07b1ad2&scoped=true&"
import script from "./CheckBoxPropertyEditor.vue?vue&type=script&lang=ts&"
export * from "./CheckBoxPropertyEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d07b1ad2",
  null
  
)

export default component.exports